module.exports = __webpack_public_path__ + "img/regenerate_language_cache.feb31896.svg";